<app-header [icon]="'close'" (iconClickedEvent)="close()"></app-header>
<app-stepper #stepper></app-stepper>

<div class="container">

  <div class="title-container">
    <div class="sub-title">
      {{ 'did_do.title' | translate }}
    </div>
  </div>

  <div class="text-area-container">
    <app-text-area
      [label]="'labels.what_did_you_do'| translate"
      [control]="whatDidDoControl"
    ></app-text-area>
  </div>

  <div class="actions-container">
    <app-button
      [buttonLabel]="'buttons.back' | translate"
      [buttonType]="BUTTON_TYPES.OUTLINED" 
      [buttonDisabled]="false"
      (click)="back()">
    </app-button>
    <app-button
      [buttonLabel]="'buttons.next' | translate"
      [buttonType]="BUTTON_TYPES.REGULAR" 
      [buttonDisabled]="false"
      (click)="next()">
    </app-button>
  </div>
</div>